export default "__VITE_ASSET__B5Emh71T__"